// source: wisetime/type/site_preferences.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.type.DirectTimelinePostPreference', null, global);
goog.exportSymbol('proto.wisetime.type.RoundingPreference', null, global);
/**
 * @enum {number}
 */
proto.wisetime.type.RoundingPreference = {
  ROUNDING_PREFERENCE_UNSPECIFIED: 0,
  PERCENTAGE_POINTS: 1,
  THREE_MIN_UNITS: 5,
  SIX_MIN_UNITS: 2,
  TWELVE_MIN_UNITS: 4,
  QUARTER_HOURS: 3
};

/**
 * @enum {number}
 */
proto.wisetime.type.DirectTimelinePostPreference = {
  DIRECT_TIMELINE_POST_PREFERENCE_UNSPECIFIED: 0,
  DIRECT_TIMELINE_POST_ENABLED: 1,
  DIRECT_TIMELINE_POST_DISABLED: 2
};

goog.object.extend(exports, proto.wisetime.type);
